module.exports = "/_next/static/images/lock-monotone-795988899cf68c7c67668e7661ed67d2.svg";